export default __webpack_public_path__ + "static/media/ActivateLogo.59381401.svg";